import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import AuthenticationLogReducer from "../reducers/AuthenticationLogReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { AuthenticationLogConstants } from "../constants/authenticationlog.constants";
import { saveFile } from "../utils/common";
const initialState = {
  authenticationLogs: [],
  authenticationLogStats: [],
  authenticationLogHistories: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  authenticationLogSearchResults: [],
  authenticationLog: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  AuthenticationLogAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },

  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: true,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const AuthenticationLogContext = createContext({
  ...initialState,
  getAllAuthenticationLog: () => {},
  getAllAuthenticationLogHistory: () => {},
  getAuthStats: () => {},
  getAllAuthenticationLogStats: () => {},

  addAuthenticationLog: () => {},
  searchAuthenticationLog: () => {},
  autoSearchAuthenticationLog: () => {},
  getAuthenticationLog: () => {},
  assignAuthenticationLog: () => {},
  updateAuthenticationLog: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function AuthenticationLogProvider({ children }) {
  const [state, dispatch] = useReducer(AuthenticationLogReducer, initialState);

  const getAllAuthenticationLog = async (payload) => {
    try {
      const response = await axios.post("/rad-auth/list", payload);
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_REQUEST,
      });
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_FAILURE,
      });
    }
  };

  const getAllAuthenticationLogHistory = async (payload) => {
    try {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_HISTORY_REQUEST,
      });
      const response = await axios.post("/rad-auth/list", payload);
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_HISTORY_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_HISTORY_FAILURE,
      });
    }
  };

  const getAuthStats = async () => {
    try {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_REQUEST,
      });
      const response = await axios.post("/rad-auth/stats");
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_FAILURE,
      });
    }
  };

  const getAllAuthenticationLogStats = async (payload) => {
    try {
      const response = await axios.post("/rad-auth/stats", payload);
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_REQUEST,
      });
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.FETCH_AUTHENTICATION_LOG_STATS_FAILURE,
      });
    }
  };

  const searchAuthenticationLog = async (payload) => {
    try {
      const response = await axios.post("/rad-auth/search", payload);
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchAuthenticationLog = async (payload) => {
    try {
      const response = await axios.post("/rad-auth/auto-search", payload);
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: AuthenticationLogConstants.AUTHENTICATION_LOG_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addAuthenticationLog = async (payload) => {
    const response = await axios.post("/rad-auth/add", payload);
    dispatch({
      type: AuthenticationLogConstants.ADD_AUTHENTICATION_LOG_REQUEST,
    });
    dispatch({
      type: AuthenticationLogConstants.ADD_AUTHENTICATION_LOG_SUCCESS,
      payload: response.data,
    });
  };

  const getAuthenticationLog = async (id) => {
    const response = await axios.get("/rad-auth/" + id);
    dispatch({
      type: AuthenticationLogConstants.GET_AUTHENTICATION_LOG_REQUEST,
    });
    dispatch({
      type: AuthenticationLogConstants.GET_AUTHENTICATION_LOG_SUCCESS,
      payload: response.data,
    });
  };

  const updateAuthenticationLog = async (payload) => {
    const response = await axios.put("/rad-auth/update/" + payload.authenticationLogId, payload);
    dispatch({
      type: AuthenticationLogConstants.UPDATE_AUTHENTICATION_LOG_REQUEST,
    });
    dispatch({
      type: AuthenticationLogConstants.UPDATE_AUTHENTICATION_LOG_SUCCESS,
      payload: response.data,
    });
  };

  const assignAuthenticationLog = async (payload) => {
    const response = await axios.post("/rad-auth/assign", payload);
    dispatch({
      type: AuthenticationLogConstants.AUTHENTICATION_LOG_ASSIGN_REQUEST,
    });
    dispatch({
      type: AuthenticationLogConstants.AUTHENTICATION_LOG_ASSIGN_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: AuthenticationLogConstants.DOWNLOAD_AUTHENTICATION_LOG_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/rad-auth/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "rad-auth." + fileType);

    dispatch({
      type: AuthenticationLogConstants.DOWNLOAD_AUTHENTICATION_LOG_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/rad-auth/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_rad-auth." + fileType);
    dispatch({
      type: AuthenticationLogConstants.DOWNLOAD_AUTHENTICATION_LOG_REQUEST,
    });
    dispatch({
      type: AuthenticationLogConstants.DOWNLOAD_AUTHENTICATION_LOG_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: AuthenticationLogConstants.UPLOAD_AUTHENTICATION_LOG_REQUEST,
      });
      const response = await axios({
        url: "/rad-auth/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: AuthenticationLogConstants.UPLOAD_AUTHENTICATION_LOG_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: AuthenticationLogConstants.UPLOAD_AUTHENTICATION_LOG_FAILURE,
      });
    }
  };

  return (
    <AuthenticationLogContext.Provider
      value={{
        ...state,
        getAllAuthenticationLog,
        getAllAuthenticationLogHistory,
        getAuthStats,
        getAllAuthenticationLogStats,
        addAuthenticationLog,
        searchAuthenticationLog,
        autoSearchAuthenticationLog,
        getAuthenticationLog,
        assignAuthenticationLog,
        updateAuthenticationLog,
        downloadFile,
        sampleFile,
        uploadFile,
      }}
    >
      {children}
    </AuthenticationLogContext.Provider>
  );
}

export { AuthenticationLogContext, AuthenticationLogProvider };
